export const signInDestination = {
  fromSearch(search: string): string | null {
    const value = new URLSearchParams(search).get("returnTo");
    if (!value || !/^\/portal(?:[/?#]|$)/.test(value) || /[\\\s]/.test(value)) return null;
    const url = new URL(value, "https://portal.invalid");
    if (
      url.origin !== "https://portal.invalid" ||
      !(url.pathname === "/portal" || url.pathname.startsWith("/portal/"))
    )
      return null;
    url.searchParams.delete("accessToken");
    return `${url.pathname}${url.search}${url.hash}`;
  },
};
